import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  User, Truck, LogOut, ChevronRight,
} from 'lucide-react';

export default function TechMore() {
  const { user, logout, assignedVanId } = useAuth();
  const navigate = useNavigate();

  const items = [
    { icon: User, label: 'Profile', desc: user?.email, action: () => navigate('/tech/profile') },
    ...(assignedVanId
      ? [{ icon: Truck, label: 'My Vehicle', desc: 'Van inventory & tools', action: () => navigate('/tech/my-vehicle') }]
      : []),
  ];

  return (
    <div className="px-4 pt-6 pb-4 max-w-lg mx-auto" data-testid="tech-more">
      {/* User header */}
      <div className="flex items-center gap-3 mb-6 px-1">
        <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center text-white text-lg font-bold">
          {(user?.name || 'T').charAt(0).toUpperCase()}
        </div>
        <div>
          <p className="text-base font-bold text-slate-950">{user?.name || 'Technician'}</p>
          <p className="text-xs text-slate-400">{user?.email}</p>
        </div>
      </div>

      {/* Menu items */}
      <div className="space-y-1">
        {items.map(({ icon: Icon, label, desc, action }) => (
          <button
            key={label}
            onClick={action}
            className="w-full flex items-center gap-3 px-3 py-3.5 rounded-xl active:bg-slate-100 text-left"
            data-testid={`more-${label.toLowerCase().replace(/\s/g, '-')}`}
          >
            <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
              <Icon className="w-5 h-5 text-slate-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold text-slate-950">{label}</p>
              {desc && <p className="text-xs text-slate-400 truncate">{desc}</p>}
            </div>
            <ChevronRight className="w-4 h-4 text-slate-300 shrink-0" />
          </button>
        ))}
      </div>

      {/* Logout */}
      <div className="mt-6 pt-6 border-t border-slate-200">
        <button
          onClick={logout}
          className="w-full flex items-center justify-center gap-2 h-12 rounded-xl bg-red-50 text-red-600 text-sm font-bold active:bg-red-100"
          data-testid="more-logout"
        >
          <LogOut className="w-4 h-4" /> Sign Out
        </button>
      </div>
    </div>
  );
}
